export default {
  common: {
    edited: 'Editado',
    error: {
      general: 'Ops!',
      failedToOpenMaps: 'Falha ao abrir o mapa',
      failedToOpenLink:
        'Falha ao abrir o link. Nenhum navegador web está disponível neste dispositivo.',
      reportTooMany: 'Você enviou muitas denúncias recentemente. Aguarde um pouco e tente novamente.',
      reportFailed: 'Não conseguimos abrir o formulário de denúncia. Tente novamente.',
      reportUnavailable: 'Este conteúdo não está mais disponível para denúncia.',
      popupBlocked:
        'Seu navegador bloqueou a abertura do formulário. Permita pop-ups para este site e tente novamente.',
      ipBlocked:
        'Seu endereço IP foi bloqueado devido a atividade suspeita. Se você acredita que isso é um erro, entre em contato com o suporte.',
      crashTitle: 'Ops! Algo deu errado',
      crashSubtitle: 'Fomos notificados e estamos investigando.',
      crashReload: 'Recarregar',
      crashRetry: 'Tentar novamente',
    },
    updateBanner: {
      message: 'Fizemos algumas melhorias',
      refresh: 'Recarregar',
    },
    connection: {
      offline: 'Sem conexão com a internet',
      connecting: 'Conectando...',
    },
    success: 'Sucesso!',
    follow: 'Seguir',
    unfollow: 'Deixar de seguir',
    followed: 'Seguindo',
    message: 'Mensagem',
    empty: 'Nada para ver aqui ainda',
    post: 'publicação',
    comment: 'comentário',
    photo: 'foto',
    month: 'mês',
    year: 'ano',
    cancel: 'Cancelar',
    continue: 'Continuar',
    back: 'Voltar',
    delete: 'Excluir',
    update: 'Atualizar',
    saveChanges: 'Salvar alterações',
    scrollToTop: 'Ir ao topo',
    undo: 'Desfazer',
    report: 'Denunciar',
    openingForm: 'Abrindo o formulário...',
    accept: 'Aceitar',
    reject: 'Rejeitar',
    retry: 'Tentar novamente',
    send: 'Enviar',
    unblock: 'Desbloquear',
    comingSoon: 'Em breve',
    loading: 'Carregando...',
    done: 'Pronto',
    clear: 'Limpar',
    clearAll: 'Redefinir',
    search: 'Pesquisar...',
    share: {
      success: 'Compartilhado com sucesso',
      error: 'Erro ao compartilhar',
      copied: 'Link copiado para a área de transferência',
      shareLink: 'Compartilhar link',
      url: 'URL',
      copy: 'Copiar',
      open: 'Abrir',
    },
    validation: {
      min: 'Deve ter pelo menos {{minLength}} caracteres',
      max: 'Deve ter no máximo {{maxLength}} caracteres',
      required: 'Este campo é obrigatório',
      requiredField: '{{field}} é obrigatório',
    },
    filters: {
      myType: 'meu tipo',
      all: 'filtros',
    },
    relativeTime: {
      now: 'agora',
      justNow: 'agora mesmo',
    },
  },
  myTypeFilter: {
    title: 'Filtro Meu Tipo',
    enableOption: 'Ativar',
    disableOption: 'Desativar',
    statusEnabled: 'Ativo',
    statusDisabled: 'Inativo',
    configure: 'Configurar…',
    configureTitle: 'Configurar Filtro Meu Tipo',
    enabled: 'Filtro Meu Tipo ativado',
    disabled: 'Filtro Meu Tipo desativado',
    enableError: 'Falha ao ativar o filtro',
    disableError: 'Falha ao desativar o filtro',
    infoTitle: 'O que é o Filtro Meu Tipo?',
    infoDescription:
      'Configure suas preferências uma vez e as listas de posts, membros e fotos mostrarão automaticamente apenas pessoas que correspondem aos seus critérios. Você pode ativar ou desativar este filtro a qualquer momento.',
    preview: 'Visualizar',
    apply: 'Aplicar',
    appliedSuccess: 'Configurações do filtro salvas',
    appliedError: 'Falha ao salvar as configurações do filtro',
    filteredOutPercent: '{{percent}}% dos membros filtrados',
    filterWarning: 'Filtrar demasiadas pessoas pode afetar sua experiência.',
  },
  sensitiveContent: {
    title: 'Conteúdo sensível',
    statusHidden: 'Oculto',
    statusVisible: 'Visível',
    configure: 'Configurar...',
  },
  navigation: {
    feeds: 'Feeds',
    people: 'Membros',
    photo: 'Foto',
    photos: 'Fotos',
    events: 'Eventos',
    discover: 'Descobrir',
  },
  communities: {
    myCommunities: 'Minhas comunidades',
    menu: {
      remove: 'Remover de Minhas comunidades',
    },
    delete: {
      confirmTitle: 'Remover comunidade',
      confirmMessage:
        'Tem certeza de que deseja remover {{communityName}} de Minhas comunidades? Você pode entrar novamente mais tarde.',
      success: 'Comunidade removida',
      error: 'Falha ao remover a comunidade',
    },
    visitSite: 'Visitar {{communityName}}',
  },
  auth: {
    createAccount: 'Criar conta',
    signIn: {
      title: 'Entrar',
      welcomeBack: 'Bem-vindo de volta!',
      heading: 'Entre em {{communityName}}',
      usernameLabel: 'Nome de usuário',
      usernamePlaceholder: 'Digite o nome de usuário',
      usernameNotFound: 'Nome de usuário não encontrado',
      passwordLabel: 'Senha',
      passwordPlaceholder: 'Digite a senha',
      passwordIncorrect: 'Senha ou nome de usuário incorretos',
      rememberMe: 'Lembrar de mim',
      forgotPassword: 'Esqueceu a senha?',
      submit: 'Entrar',
      submitting: 'Entrando...',
      noAccount: 'Não tem uma conta?',
      signUp: 'Cadastre-se',
      loginFailedToast: 'Falha no login',
      removeCredentialsError: 'Falha ao remover credenciais',
      unexpectedError: 'Ocorreu um erro inesperado',
    },
    signUp: {
      redirectHelper:
        'Você será redirecionado para o nosso site legado do {{communityName}} para criar uma conta. Depois de criar sua conta, você pode voltar para este app para entrar.',
      successToast: 'Conta criada. Enviamos sua senha por e‑mail.',
    },
    forgotPassword: {
      title: 'Esqueci minha senha',
      redirectHelper:
        'Você será redirecionado para o nosso site legado do {{communityName}} para redefinir sua senha. Depois de receber a nova senha por e-mail, volte para o app para entrar.',
      successToast: 'Enviamos uma nova senha por e‑mail.',
    },
  },
  feeds: {
    global: 'Feed global',
    global_short: 'Global',
    local: 'Feed local',
    local_short: 'Local',
    network: 'Feed de seguindo',
    network_short: 'Seguindo',
    search: 'Pesquisa',
    search_short: 'Pesquisar',
    search_placeholder: 'Pesquisa nas publicações',
    empty: 'Desculpe, não há resultados',
    latestSearches: 'Pesquisas recentes',
    popularSearches: 'Pesquisas populares',
    popularHashtags: 'Hashtags populares',
    onlineMembers: 'Online agora',
    profileVisitors: 'Visitaram meu perfil',
    searchMembersHint: 'Procurando alguem?',
    searchMembersLink: 'Buscar membros',
    pinned: 'Definido como feed padrão',
    unpinned: 'Feed global restaurado como padrão',
    alreadyDefault: 'Este já é o seu feed padrão. Mude para outro feed para alterá-lo.',
    radius: {
      title: 'Raio',
      km: 'km',
      mi: 'mi',
    },
  },
  messages: {
    title: 'Mensagens',
    inbox: 'Caixa de entrada',
    inboxBadgeUnreadCaption_one: 'não lida',
    inboxBadgeUnreadCaption_other: 'não lidas',
    inboxBadgeMessagesCaption_one: 'mensagem',
    inboxBadgeMessagesCaption_other: 'mensagens',
    unread: 'Não lidos',
    online: 'Online',
    deleted: 'Excluídos',
    emptyDeleted: 'Nenhuma conversa excluída nos últimos 90 dias',
    search: 'Pesquisar',
    search_placeholder: 'Digite um nome de usuário',
    empty: 'Nenhuma mensagem para mostrar',
    conversation: 'Conversa',
    emptyConversation: 'Nenhum item de conversa para mostrar',
    typeMessage: 'Digite uma mensagem...',
    photoMessage: 'enviou uma foto',
    gifMessage: 'enviou um GIF',
    stickerMessage: 'enviou um sticker',
    clipMessage: 'enviou um clip',
    youSentPhoto: 'Você enviou uma foto',
    youSentGif: 'Você enviou um GIF',
    youSentSticker: 'Você enviou um sticker',
    youSentClip: 'Você enviou um clip',
    replyFailed: 'Falha ao enviar resposta',
    compose: {
      messageToUser: 'Mensagem para {{userName}}',
      enterMessage: 'Digite sua mensagem...',
    },
    errors: {
      failedToLoad: 'Falha ao carregar conversa',
      failedToSend: 'Falha ao enviar mensagem',
    },
    success: {
      messageSent: 'Mensagem enviada com sucesso',
    },
    loadOlderMessages: 'Carregar mensagens anteriores',
    loadingOlderMessages: 'Carregando mensagens anteriores...',
    loadingNewerMessages: 'Carregando novas mensagens...',
    markAsRead: {
      error: 'Falha ao marcar mensagem como lida',
    },
    markAsUnread: {
      error: 'Falha ao marcar mensagem como não lida',
    },
    delete: {
      success: 'Mensagem excluída com sucesso',
      error: 'Falha ao excluir mensagem',
    },
    undelete: {
      success: 'Mensagem restaurada com sucesso',
      error: 'Falha ao restaurar mensagem',
    },
    menu: {
      markRead: 'Marcar como lida',
      markUnread: 'Marcar como não lida',
      viewProfile: 'Ver perfil',
      deleteConversation: 'Excluir conversa',
      restoreConversation: 'Restaurar conversa',
      reportConversation: 'Denunciar conversa',
    },
    copy: {
      success: 'Conteúdo copiado para a área de transferência',
      error: 'Falha ao copiar conteúdo',
      noContent: 'Nenhum conteúdo para copiar',
    },
    download: {
      label: 'Salvar foto',
      success: 'Foto salva na sua biblioteca',
      error: 'Não foi possível salvar a foto',
      permissionDenied: 'É preciso permitir acesso à biblioteca de fotos para salvar fotos',
    },
    unreadMessage: 'Mensagem não lida',
    uploadPhoto: 'Enviar imagem',
    dropImageToSend: 'Solte a imagem para enviar',
    dropImageToSendToUser: 'Solte a imagem para enviar para {{userName}}',
    sendPhoto: 'Enviar foto',
    photoUploadFailed: 'Falha no envio da imagem',
    photoUploadSuccess: 'Imagem enviada com sucesso',
    selectPhoto: 'Fotos',
    takePhoto: 'Câmera',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    cameraPermissionNotGranted: 'Permissão de câmera não concedida',
    mediaLibraryPermissionNotGranted: 'Permissão de biblioteca de mídia não concedida',
    failedToPickImage: 'Falha ao selecionar imagem',
    imageTooLarge: 'A imagem é muito grande. O tamanho máximo é {{size}}MB.',
    adminClosedInfo:
      'Esta conversa está encerrada. Para qualquer acompanhamento, abra um ticket de suporte e inclua os detalhes relevantes.',
    contactSupport: 'Contactar suporte',
    newAccountNotice: {
      title: '{{name}} entrou recentemente',
      body: 'Vá com calma ao conhecer novos membros. Tenha cuidado ao compartilhar informações pessoais e desconfie se pedirem para levar a conversa para o Telegram, WhatsApp, SMS ou qualquer outro serviço de mensagens.',
    },
  },
  people: {
    nearby: 'Membros próximos',
    nearby_short: 'Próximas',
    online: 'Membros online',
    online_short: 'Online',
    birthdays: 'Aniversários',
    birthdays_short: 'Aniversários',
    new: 'Novos membros',
    new_short: 'Novos',
    following: 'Membros que sigo',
    following_short: 'Seguindo',
    followers: 'Meus seguidores',
    followers_short: 'Seguidores',
    visitors: 'Meus visitantes',
    visitors_short: 'Visitantes',
    search: 'Busca de membros',
    search_short: 'Buscar',
    empty: 'Desculpe, isso está vazio',
    displayModeCompact: 'Vista compacta',
    displayModeRegular: 'Vista normal',
    nearbyFilter: {
      online: 'Online',
      recent: 'Recentes',
      active: 'Últimos 90 dias',
      newmembers: 'Novos',
      all: 'Todos',
    },
  },
  search: {
    username: 'Nome de usuário',
    usernamePlaceholder: 'Pesquisar por nome de usuário',
    location: 'Localização',
    nearMe: 'Perto de mim',
    anywhere: 'Em qualquer lugar',
    customLocation: 'Localização personalizada',
    ranges: 'Intervalos',
    age: 'Idade',
    bmi: 'IMC',
    filters: 'Filtros',
    additional: 'Filtros adicionais',
    hasPhotos: 'Tem fotos',
    hasPrivatePhotos: 'Tem fotos privadas',
    isOnline: 'Atualmente online',
    isActive: 'Ativo nos últimos 90 dias',
    isNew: 'Novo membro',
    isFollower: 'Me segue',
    imFollowing: 'Seguindo',
    imTheirBodyType: 'Interesse no meu tipo de corpo',
    clearAll: 'Redefinir',
    search: 'Pesquisar',
    anything: 'Qualquer coisa',
    to: 'a',
    andUnder: 'e abaixo',
    andAbove: 'e acima',
    multipleSelected: '{{count}} selecionados',
    selectedCount: '{{count}} selecionados',
    noneSelected: 'Nenhum selecionado',
    selectAtLeastOneFilter: 'Por favor, seleciona pelo menos um filtro para começar a tua pesquisa',
    restoredFiltersTitle: 'Filtros restaurados',
    restoredFiltersDescription:
      'Os filtros da tua última pesquisa foram restaurados. Queres começar do zero? Clica no botão redefinir abaixo.',
  },
  discover: {
    seeMore: 'Ver mais',
    tabBarHintLead: 'Suas abas têm um menu secreto',
    tabBarHintBody: 'Pressione e segure, deslize e vá para qualquer lista em um movimento.',
    sectionSubtitles: {
      photos: {
        latest: 'Fotos públicas da comunidade',
        network: 'Fotos públicas de membros que você segue',
        private: 'Fotos privadas de membros que te deixam entrar',
        favorites: 'Fotos que você curtiu',
      },
      events: {
        upcoming: 'Todos os eventos futuros da comunidade',
        nearby: 'Eventos futuros em até {{distance}}',
        network: 'Eventos que membros que você segue vão participar',
        past: 'Eventos passados arquivados da comunidade',
      },
    },
  },
  photos: {
    photoOf: 'Foto de {{userName}}',
    posted: 'Publicado',
    latest: 'Últimas fotos (Todos)',
    latest_short: 'Últimas',
    network: 'Últimas fotos (Seguindo)',
    network_short: 'Seguindo',
    private: 'Últimas fotos (Privadas)',
    private_short: 'Privadas',
    favorites: 'Fotos favoritas',
    favorites_short: 'Favoritas',
    addPublicPhoto: 'Adicionar uma foto pública',
    addPrivatePhoto: 'Adicionar uma foto privada',
    dropToUploadPublic: 'Solte para enviar para Público',
    dropToUploadPrivate: 'Solte para enviar para Privado',
    captionPlaceholder: 'Adicione uma legenda (opcional)',
    uploadSuccess: 'Foto enviada',
    uploadFailed: 'Falha ao enviar a foto',
    uploadingImage: 'Enviando imagem...',
    policyLink: 'Leia nossa política de fotos',
    artworkNotice:
      'Imagens geradas por IA devem ser identificadas como tal e publicadas com moderação.',
    artworkNoticeFerzu:
      'As obras de arte devem ser creditadas. Imagens geradas por IA não são permitidas.',
    empty: 'Nenhuma foto para mostrar',
    sensitiveReminder: {
      title: 'Fotos sensíveis e não revisadas estão ocultas',
      body: 'Suas configurações de segurança ocultam fotos sensíveis e não revisadas. Você pode alterar essa preferência a qualquer momento em Filtros ou Configurações.',
      action: 'Revisar opções de segurança',
      dismiss: 'Ignorar',
    },
  },
  photo: {
    menu: {
      editCaption: 'Editar legenda',
      useAsProfilePhoto: 'Usar como foto de perfil',
      moveToPrivate: 'Mover para pasta privada',
      requestReview: 'Solicitar revisão',
      report: 'Denunciar foto',
      delete: 'Excluir foto',
    },
    caption: {
      placeholder: 'Adicione uma legenda (opcional)',
      updateSuccess: 'Legenda atualizada',
      updateError: 'Falha ao atualizar a legenda',
    },
    profile: {
      confirmTitle: 'Usar como foto de perfil',
      confirmMessage: 'Tem certeza de que deseja usar esta como sua foto de perfil?',
      setSuccess: 'Foto de perfil atualizada',
      setError: 'Falha ao atualizar a foto de perfil',
    },
    private: {
      success: 'Foto movida para pasta privada',
      error: 'Falha ao mover a foto para a pasta privada',
    },
    locked: {
      message:
        'Atualize sua conta para {{premiumPlan}} para ver fotos ilimitadas em listas e tela cheia.',
    },
    review: {
      requestSuccess: 'Revisão solicitada',
      requestError: 'Falha ao solicitar revisão',
      dialogTitle: 'Classificação da foto',
      dialogIntro:
        'Se você acha que nosso sistema de classificação baseado em IA ou revisores humanos cometeram um erro ao determinar a classificação da sua foto, ou se deseja mover uma foto da sua pasta Privada para Pública, você pode solicitar uma revisão manual para que a foto seja avaliada novamente. Lembre-se de que cada foto só pode ser revisada uma vez e o processo pode levar algumas horas.',
      possibleRatingsTitle: 'As classificações possíveis são:',
    },
    delete: {
      confirmTitle: 'Excluir foto',
      confirmMessage:
        'Tem certeza de que deseja excluir esta foto? Esta ação não pode ser desfeita.',
      success: 'Foto excluída com sucesso',
      error: 'Falha ao excluir a foto',
    },
  },
  events: {
    upcoming: 'Próximos eventos',
    upcoming_short: 'Próximos',
    nearby: 'Eventos por perto',
    nearby_short: 'Por perto',
    network: 'Eventos da rede',
    network_short: 'Rede',
    attending: 'Participando',
    attend: 'Participar',
    unattend: 'Não participar',
    follow: 'Seguir',
    following: 'Seguindo',
    attendees: 'participantes',
    attendees_one: 'participante',
    attendees_other: 'participantes',
    attendees_short: 'Participantes',
    followers: 'seguidores',
    followers_one: 'seguidor',
    followers_other: 'seguidores',
    followers_short: 'Seguidores',
    past: 'Eventos passados',
    past_short: 'Passados',
    organizer: 'Organizador',
    curator: 'Curador',
    curatorNotice:
      'Esta pessoa ajuda a manter as listagens de eventos. Por favor, reporte qualquer imprecisão. Se fores o organizador do evento, podes assumir esta página entrando em contacto com {{communityName}}.',
    date_time: 'Data e hora',
    location: 'Local',
    website: 'Site',
    empty: 'Nenhum evento para exibir',
    noEventsForMember: 'Nenhum evento ainda',
    attendeesCount_one: '{{count}} participante',
    attendeesCount_other: '{{count}} participantes',
    attendSuccess: 'Você está participando deste evento',
    unattendSuccess: 'Você não está mais participando deste evento',
    attendError: 'Não foi possível confirmar a participação',
    unattendError: 'Não foi possível cancelar a participação',
    followError: 'Não foi possível seguir o evento',
    unfollowError: 'Não foi possível deixar de seguir o evento',
    createSuccess: 'Evento criado',
    updateSuccess: 'Evento atualizado',
    createError: 'Não foi possível criar o evento',
    updateError: 'Não foi possível atualizar o evento',
    deleteSuccess: 'Evento excluído',
    deleteError: 'Não foi possível excluir o evento',
    deleteEvent: 'Excluir evento',
    deleteConfirmTitle: 'Excluir evento?',
    deleteConfirmMessage:
      'Tem certeza de que deseja excluir este evento? Esta ação não pode ser desfeita.',
    createEvent: 'Novo evento',
    editEvent: 'Editar evento',
    form: {
      code: 'Código do evento',
      codePlaceholder: 'ex. meu-evento-2026',
      codeHint: 'Letras, números, hífens e underscores. Não pode começar com um número.',
      name: 'Nome do evento',
      namePlaceholder: 'Digite o nome do evento',
      nameHint:
        'Evite incluir a data ou o mês no nome do evento. Se precisar, adicione no final do nome.',
      startDate: 'Data de início',
      endDate: 'Data de término (opcional)',
      selectDate: 'Selecionar uma data',
      startTime: 'Hora de início',
      endTime: 'Hora de término',
      selectTime: 'Definir hora',
      timesError: 'Define as duas horas ou nenhuma',
      location: 'Localização',
      selectLocation: 'Selecionar localização',
      venue: 'Local, salão ou hotel',
      venuePlaceholder: 'ex. Centro de convenções',
      website: 'Site',
      websitePlaceholder: 'https://seusite.com',
      websiteError: 'A URL do site deve começar com https://',
      details: 'Detalhes do evento',
      detailsPlaceholder: 'Descreva o evento...',
      organizer: 'Sou o organizador deste evento',
      save: 'Salvar alterações',
      create: 'Criar evento',
      required: 'Obrigatório',
    },
    addToCalendar: 'Adicionar ao calendário',
    share: {
      title: 'Confira este evento',
      message: 'Confira {{eventName}}',
      shareEvent: 'Compartilhar evento',
    },
  },
  post: {
    like_one: '{{count}} curtida',
    like_other: '{{count}} curtidas',
    comment_one: '{{count}} comentário',
    comment_other: '{{count}} comentários',
    addComment: 'Comentar',
    announcement: 'Anúncio',
    singlePost: 'Publicação',
    newPost: 'Nova publicação',
    placeholder: 'O que você está pensando?',
    compose: {
      wallPlaceholder: 'Escreva no mural de {{userName}}...',
    },
    publish: 'Publicar',
    createSuccess: 'Sua publicação foi publicada',
    createError: 'Falha ao publicar a publicação',
    editSuccess: 'Sua publicação foi atualizada',
    editError: 'Falha ao atualizar a publicação',
    readMore: 'Leia mais',
    featuredPhoto: {
      warningWithReset:
        'Parece que você postou outra foto muito recentemente, o que significa que esta foto não será destacada no feed global, a menos que você espere {{minutes}} minutos para postá-la',
    },
    menu: {
      edit: 'Editar a publicação',
      dismissAnnouncement: 'Ocultar o anúncio',
      share: 'Compartilhar a publicação',
      stopNotifications: 'Desativar notificações',
      resumeNotifications: 'Retomar notificações',
      report: 'Denunciar a publicação',
      delete: 'Excluir a publicação',
    },
    mute: {
      title: 'Desativar notificações por quanto tempo?',
      oneHour: '1 hora',
      eightHours: '8 horas',
      oneDay: '24 horas',
      indefinitely: 'Indefinidamente',
      success: 'Notificações para esta publicação desativadas com sucesso',
      error: 'Falha ao desativar as notificações para esta publicação',
    },
    unmute: {
      success: 'Notificações para esta publicação retomadas com sucesso',
      error: 'Falha ao retomar as notificações para esta publicação',
    },
    getMutedState: {
      error: 'Falha ao obter o estado das notificações',
    },
    dismissAnnouncement: {
      success: 'Anúncio ocultado',
      error: 'Falha ao ocultar o anúncio',
    },
    delete: {
      confirmTitle: 'Excluir publicação',
      confirmMessage:
        'Tem certeza de que deseja excluir a publicação? Esta ação não pode ser desfeita.',
      success: 'Publicação excluída com sucesso',
      error: 'Falha ao excluir a publicação',
    },
    share: {
      title: 'Compartilhar publicação',
      message: 'Confira esta publicação de {{userName}}',
      success: 'Publicação compartilhada com sucesso',
      copied: 'Link copiado para a área de transferência',
      error: 'Falha ao compartilhar publicação',
      shareLink: 'Compartilhar link',
      copy: 'Copiar',
      open: 'Abrir',
      postUrl: 'URL da publicação',
    },
  },
  media: {
    gif_button_label: 'Adicionar um GIF',
    no_results: 'Nenhum GIF encontrado',
    failed_to_load: 'Não foi possível carregar o GIF',
    search_placeholder: 'Pesquisar no {{provider}}',
    powered_by: 'Desenvolvido por {{provider}}',
  },
  comments: {
    title: 'Comentários',
    titleOnItem: 'Comentários em {{itemType}} de {{userName}}',
    empty: 'Seja o primeiro a comentar!',
    add_placeholder: 'Adicionar um comentário...',
    added: 'Seu comentário foi publicado',
    add_error: 'Falha ao publicar o comentário',
    editSuccess: 'Seu comentário foi atualizado',
    editError: 'Falha ao atualizar o comentário',
    menu: {
      edit: 'Editar o comentário',
      report: 'Denunciar o comentário',
      delete: 'Excluir o comentário',
    },
    delete: {
      confirmTitle: 'Excluir comentário',
      confirmMessage:
        'Tem certeza de que deseja excluir o comentário? Esta ação não pode ser desfeita.',
      success: 'Comentário excluído com sucesso',
      error: 'Falha ao excluir o comentário',
    },
    viewMore_one: 'Ver {{count}} comentario a mais',
    viewMore_other: 'Ver mais {{count}} comentarios',
  },
  likes: {
    title: 'Curtidas',
    titleOnItem: 'Curtidas em {{itemType}} de {{userName}}',
  },
  notifications: {
    title: 'Notificações',
    titleNative: 'Notificações push',
    empty: 'Ainda não há notificações',
    newNotifications: 'Novas notificações',
    clearAll: 'Limpar tudo',
    clearAllConfirmTitle: 'Limpar notificações',
    clearAllConfirmMessage:
      'Isso vai dispensar todas as suas notificações, incluindo solicitações pendentes de acesso às suas fotos privadas. Continuar?',
    clearAllSuccess: 'Notificações limpas',
    clearAllError: 'Falha ao limpar as notificações',
    dismiss: 'Dispensar notificação',
    dismissSuccess: 'Notificação dispensada',
    dismissError: 'Falha ao dispensar a notificação',
    andOthers_one: '(e {{count}} outro)',
    andOthers_other: '(e {{count}} outros)',
    unlockAcceptSuccess: 'Solicitação de desbloqueio aceita',
    unlockAcceptError: 'Falha ao aceitar a solicitação de desbloqueio',
    unlockRejectSuccess: 'Solicitação de desbloqueio rejeitada',
    unlockRejectError: 'Falha ao rejeitar a solicitação de desbloqueio',
    permissionDisabledTitle: 'As notificações push estão desativadas',
    permissionDisabledDescription:
      'Ative as notificações nas configurações para não perder novas atividades.',
    openSettings: 'Abrir configurações',
  },
  settings: {
    title: 'Configurações',
    appearance: 'Aparência',
    location: {
      title: 'Localização',
      current: 'Publicado como',
      mode: 'Nome do lugar',
      fixed: 'Fixo',
      automatic: 'Automático',
      enable: 'Ativar localização...',

      enableHelp: 'Ativar localização',
      enableHelpBlocked: 'Seu navegador esta bloqueando o acesso a sua localização',
      enableHelpSteps:
        'Para ativar, siga os passos abaixo:\n\n\u2022 Abra o menu de informações do site perto da barra de endereço (icone de cadeado, configurações ou informações).\n\u2022 Encontre as permissões para este site e localize a configuração de localização.\n\u2022 Mude a localização para Permitir (ou Perguntar sempre).\n\u2022 Recarregue a pagina.',
      tips: 'Dicas e privacidade',
      fixedSet: 'Localização publicada atualizada',
      fixedError: 'Falha ao definir a localização',
      searchPlaceholder: 'Cidade, CEP ou endereço',
      searchHint: 'Digite pelo menos 2 caracteres',
      noResults: 'Nenhum lugar correspondente. Verifique a ortografia ou tente uma cidade próxima.',
      searchError: 'Falha na pesquisa de locais',
      pickPlace: 'Escolha um lugar',
      autoDescription:
        'O nome do lugar (cidade) que aparece no seu perfil será atualizado conforme você viaja',
    },
    account: {
      title: 'Conta',
      username: {
        title: 'Alterar nome de usuário',
        title_short: 'Nome de usuário',
        label: 'Novo nome de usuário',
        placeholder: 'Digite o novo nome de usuário',
        helper:
          'Escolha um novo nome de usuário de 2 a 20 caracteres que comece com uma letra. Apenas letras, dígitos, - e _ são permitidos.',
        invalid: 'Nome de usuário inválido',
        unavailable: 'Este nome de usuário já está em uso',
        current: 'Usuário:',
        updateAndSignOut: 'Atualizar e sair',
        successSignOut: 'Nome de usuário atualizado. Entre novamente com seu novo nome de usuário.',
        error: 'Falha ao atualizar o nome de usuário',
      },
      email: {
        title: 'Alterar e-mail',
        title_short: 'E-mail',
        label: 'Novo e-mail',
        placeholder: 'Digite o novo e-mail',
        changeExplanation:
          'Enviaremos um link de confirmação para o novo endereço. Seu e-mail será alterado após a confirmação.',
        invalid: 'Digite um e-mail válido',
        unavailable: 'Este e-mail já está em uso',
        current: 'E-mail:',
        success: 'Solicitação de troca de e-mail enviada. Verifique sua caixa de entrada.',
        error: 'Falha ao atualizar o e-mail',
      },
      password: {
        title: 'Alterar senha',
        change: 'Alterar senha',
        old: 'Senha atual',
        new: 'Nova senha (mín. 6 caracteres)',
        repeat: 'Repita a nova senha',
        mismatch: 'As senhas não coincidem',
        oldRequired: 'Digite sua senha atual',
        success: 'Senha atualizada',
        error: 'Falha ao atualizar a senha',
      },
      delete: {
        title: 'Excluir conta',
        confirmLabel: 'Confirme com sua senha atual',
        confirmMessage: 'Esta ação é permanente. Digite sua senha para confirmar.',
        placeholder: 'Digite a senha atual',
        submit: 'Excluir minha conta',
        required: 'Digite sua senha atual',
        success: 'Sua conta foi excluída',
        error: 'Falha ao excluir a conta',
      },
    },
    privacy: {
      title: 'Privacidade e Segurança',
      blockedMembers: 'Membros bloqueados',
      photoUnlockAuthorized: 'Autorizações de fotos privadas',
      emptyHelp: {
        blocked:
          'Os membros que você bloquear aparecerão aqui. Você pode remover os bloqueios a qualquer momento.',
        photoUnlockAuthorized:
          'Os membros a quem você concedeu acesso às suas fotos privadas aparecerão aqui. Você pode revogar o acesso a qualquer momento.',
      },
      removeUnlock: {
        title: 'Remover acesso',
        action: 'Remover acesso',
        confirmMessage: 'Remover o acesso às suas fotos privadas para {{userName}}?',
        success: 'Acesso removido',
        error: 'Falha ao remover o acesso',
      },
    },
    language: 'Idioma',
    system: 'Igual ao sistema',
    community: 'Comunidade',
    pattern: 'Padrão do cabeçalho',
    patterns: {
      none: 'Nenhum',
      bones: 'Ossos e patas',
      circles: 'Círculos',
      food: 'Comida',

      japanese: 'Japonês',
      plaid: 'Xadrez',
      polygonal: 'Poligonal',
      sprinkles: 'Confetes',
      stars: 'Estrelas',
      triangles: 'Triângulos',
    },
    appIcon: {
      title: 'Icone do app',
      description: 'Escolha o icone que aparece na sua tela inicial.',
      changed: 'Icone do app atualizado',
    },
    theme: {
      title: 'Tema',
      auto: 'Igual ao sistema',
      light: 'Modo claro',
      dark: 'Modo escuro',
    },
    units: {
      title: 'Unidades',
      distance: 'Distância',
      distanceKm: 'Quilômetros (km)',
      distanceMi: 'Milhas (mi)',
      height: 'Altura',
      heightM: 'Metros (m)',
      heightFt: 'Pés (ft)',
      weightUnit: 'Peso',
    },
    diagnostics: {
      title: 'Ferramentas de diagnóstico',
      signalr: 'Diagnóstico do SignalR',
      clearCache: 'Limpar cache',
      cacheCleared: 'Cache limpo com sucesso',
    },
    preferences: {
      title: 'Preferências',
      birthdayList: 'Lista de aniversários',
      birthdayListDescription: 'Mostrar-me na lista de aniversários',
      anonymousViewing: 'Visualização anônima',
      anonymousViewingDescription: 'Navegar perfis sem aparecer na lista de visitantes',
      inboundMessagePhotos: 'Fotos recebidas',
      inboundMessagePhotosDescription:
        'Permitir fotos em DMs de qualquer pessoa (caso contrário, apenas de pessoas que você segue)',
      emailNotifications: 'Notificações por e-mail',
      emailNotificationsDescription: 'Receber e-mails para novas mensagens',
      photosInNewsfeed: 'Fotos no feed',
      photosInNewsfeedDescription: 'Mostrar posts com fotos no feed global',
      mediaInComments: 'Mostrar GIFs nos comentários',
      mediaInCommentsDescription:
        'Mostra GIFs e outras mídias nos comentários de posts e fotos.',
      safeModeOff: 'Mídia sensível e não revisada',
      safeModeOffDescription: 'Exibir mídia que pode conter conteúdo sensível (NSFW)',
    },
    safety: {
      title: 'Opções de segurança',
    },
    notifications: {
      title: 'Notificações',
      titleWithSounds: 'Notificações e sons',
      description: 'Escolha quais atividades acionam notificações push',
      futureNotifications:
        'As seguintes notificações push estão planejadas para implementação futura e não estão ativas atualmente.',
      newMessage: 'Novas mensagens',
      newMessageDescription: 'Quando alguém lhe enviar uma mensagem',
      newFollower: 'Novos seguidores',
      newFollowerDescription: 'Quando alguém seguir você',
      newPhotoComment: 'Comentários em fotos',
      newPhotoCommentDescription: 'Quando alguém comentar suas fotos',
      newPostComment: 'Comentários em posts',
      newPostCommentDescription: 'Quando alguém comentar seus posts',
      newWallPost: 'Posts no mural',
      newWallPostDescription: 'Quando alguém postar no seu mural',
      web: {
        mobileTitle: 'As notificações push não estão disponíveis na web',
        mobileSubtitle:
          'Instale o app de iOS ou Android para receber notificações push quando alguém te enviar mensagem ou interagir com seu conteúdo.',
        soundsDescription:
          'Escolha um som para tocar quando algo novo chegar. Os sons são reproduzidos pelo seu navegador, então mantenha a aba {{communityName}} aberta.',
        messageSoundLabel: 'Som de nova mensagem',
        notificationSoundLabel: 'Som de nova notificação',
        preview: 'Ouvir o som',
        appStoreButton: 'Baixar na App Store',
        googlePlayButton: 'Disponível no Google Play',
      },
      sounds: {
        off: 'Desligado',
        trill: 'Trinado',
        stepUp: 'Subida',
        bubblePop: 'Pop de bolha',
        marimba: 'Marimba',
        metro: 'Metrô',
        retro: 'Retrô',
        sparkle: 'Brilho',
        strings: 'Cordas',
      },
    },
    dangerZone: 'Zona de perigo',
    about: {
      title: 'Sobre este app',
      version: 'Versão',
      build: 'compilação',
      madeWithCities: 'Feito com ❤️ em Montreal, Nova York e São Francisco',
      whatsNew: 'Novidades desta versão',
    },
  },
  whatsNew: {
    title: 'Novidades',
    currentReleaseTitle: 'Nesta versão',
    catchUpReleaseTitle: 'Desde a ultima atualizacao',
    recentUpdatesTitle: 'Atualizacoes recentes',
    lineageLabel: 'Versão {{lineage}}',
    empty: 'Nenhuma novidade para mostrar.',
    neverShowAgain: 'Não mostrar novamente',
    showOnNewVersions: 'Mostrar esta tela em novas versões',
  },
  upgrade: {
    prompt: 'Obtenha fotos em tamanho completo no seu feed sem limite diário',
    upgrade_button: 'Obter Premium',
  },
  premium: {
    upgradeCard: {
      photos: '...e muito mais! Atualize para {{premiumPlan}} para ver todas as fotos.',
      members: '...e muito mais! Atualize para {{premiumPlan}} para ver todos os membros.',
      conversation: 'Atualize para {{premiumPlan}} para acessar todo o seu histórico de conversas.',
    },
  },
  paywall: {
    ViewFullsizePhoto:
      'Limite atual atingido para visualizar fotos em tamanho completo. Atualize para {{premiumPlanName}} para acesso ilimitado.',
    OutgoingCommunication:
      'Limite atual atingido para enviar mensagens e publicações. Atualize para {{premiumPlanName}} para comunicação ilimitada.',
    NewsfeedSearch:
      'Limite atual atingido para pesquisas no feed. Atualize para {{premiumPlanName}} para pesquisas ilimitadas.',
    ValidateGiftCertificate: 'Limite atual atingido para validações de certificados de presente.',
    Blocks:
      'Você atingiu o número máximo de membros bloqueados. Atualize para {{premiumPlanName}} para mais bloqueios.',
    BlockingAMember:
      'Você recentemente bloqueou ou desbloqueou este membro. Por favor aguarde 3 dias antes de bloqueá-lo ou desbloqueá-lo novamente.',
    PostsPerHour:
      'Você atingiu seu limite de publicações por hora. Por favor aguarde antes de publicar novamente.',
    ChangeOfEmail:
      'Limite atual atingido para solicitações de mudança de e-mail. Por favor tente amanhã.',
    PhotoStream:
      'Limite atual atingido para visualizar transmissões de fotos. Atualize para {{premiumPlanName}} para acesso ilimitado.',
    FeaturedPhotos:
      'Você só pode destacar uma foto no feed global por hora. Por favor aguarde antes de publicar outra.',
    PhotoUnlockRequests:
      'Limite atual atingido para solicitações de desbloqueio de fotos. Atualize para {{premiumPlanName}} para solicitações ilimitadas.',
    AnonymousViewing:
      'A visualização anônima requer assinatura {{premiumPlanName}}. Atualize para navegar perfis sem aparecer nas listas de visitantes.',
    PostsPerDay: 'Você atingiu seu limite de publicações diárias. Por favor tente amanhã.',
    UploadedPhotos:
      'Você atingiu seu limite de fotos. Atualize para {{premiumPlanName}} para fazer upload de mais fotos.',
    UploadedPhotosPerDay:
      'Você atingiu seu limite diário de upload de fotos. Atualize para {{premiumPlanName}} para fazer upload de mais fotos hoje.',
    MemberSearch:
      'Você atingiu o limite diário de buscas. Atualize para {{premiumPlanName}} para buscas ilimitadas.',
    MyTypeFilterChange:
      'Você atingiu o limite diário para alterar seu filtro de tipo. Atualize para {{premiumPlanName}} para alterá-lo quando quiser.',
    default: 'Este recurso requer uma conta {{premiumPlanName}}. Atualize para continuar.',
    resetIn: {
      minutes_one: 'Tentar novamente em {{count}} minuto',
      minutes_other: 'Tentar novamente em {{count}} minutos',
      hours_one: 'Tentar novamente em {{count}} hora',
      hours_other: 'Tentar novamente em {{count}} horas',
    },
  },
  notFound: {
    title: 'Desculpe, não conseguimos encontrar o que você está procurando.',
    goHome: 'Voltar à tela inicial',
  },
  communitiesHeader: {
    title: 'Comunidades',
  },
  profile: {
    aboutMe: 'Sobre mim',
    stats: 'Estatísticas',
    bio: 'Biografia',
    height: 'Altura',
    weight: 'Peso',
    gender: 'Gênero',
    origin: 'Origem',
    relationship: 'Relacionamento',
    languages: 'Idiomas',
    interestedIn: 'Interessado em',
    preferences: 'Preferências',
    lookingFor: 'Procura',
    bodyTypesLiked: 'Tipos de corpo',
    bodyPartsLiked: 'Características corporais',
    sexualInterests: 'Interesses sexuais',
    mutualKinks: 'Fetiches mútuos',
    // Shared field labels (used by search, profile view, and edit profile)
    identifyAs: 'Se identifica como',
    relationshipStatus: 'Estado de relacionamento',
    bodyTypes: 'Tipos de corpo',
    bodyHair: 'Pelos corporais',
    facialHair: 'Pelos faciais',
    communityKinks: 'Fetiches da comunidade',
    otherKinks: 'Outros fetiches',
    // Section titles
    sections: {
      identity: 'Identidade e histórico',
      interestsAndKinks: 'Interesses e fetiches',
      bodyFeatures: 'Tipos de corpo e características',
    },
    // Units
    units: {
      weight: {
        pounds: 'Libras (lb)',
        kilograms: 'Quilogramas (kg)',
        stones: 'Stones (st)',
        short: {
          lb: 'lb',
          kg: 'kg',
          st: 'st',
        },
        suffix: {
          lbs: 'lbs',
          kg: 'kg',
          st: 'st',
        },
      },
      height: {
        feet: 'Pés (ft)',
        meters: 'Metros (m)',
        short: {
          ft: 'ft',
          m: 'm',
        },
        suffix: {
          m: 'm',
        },
      },
    },
    lastSeen: 'Visto pela última vez',
    lastVisitedYou: 'Viu seu perfil',
    notYet: 'Ainda não',
    activity: 'Atividade',
    joinDateWithCommunity: 'No {{communityName}} desde',
    seeAllPhotos: 'Ver tudo',
    followers: 'seguidores',
    followers_one: 'seguidor',
    followers_other: 'seguidores',
    following: 'seguindo',
    following_one: 'seguindo',
    following_other: 'seguindo',
    follows_you: 'Segue você',
    followersCount_one: '{{count}} seguidor',
    followersCount_other: '{{count}} seguidores',
    followingCount: '{{count}} seguindo',
    followersOfUser: 'Seguidores de {{userName}}',
    followingOfUser: '{{userName}} está seguindo',
    tabs: {
      about: 'Sobre',
      posts: 'Posts',
      photos: 'Fotos',
      events: 'Eventos',
      weight: 'Peso',
      wall: 'Mural',
    },
    photos: {
      public: 'Públicas',
      private: 'Privadas',
      privateLocked: 'As fotos privadas estão bloqueadas',
      requestAccess: 'Solicitar acesso',
      extendedPreviewNotice: 'Você vê mais fotos porque este membro tem {{premiumPlan}}.',
      requestPending: 'Sua solicitação para acessar fotos privadas está aguardando aprovação',
      requestSubmitted: 'Solicitação de acesso enviada',
      requestFailed: 'Falha ao enviar a solicitação de acesso',
    },
    wall: {
      empty: 'Nenhuma publicação para mostrar',
    },
    share: {
      title: 'Compartilhar perfil',
      message: 'Confira o perfil de {{userName}}',
      shareProfile: 'Compartilhar perfil',
    },
  },
  member: {
    notFound: 'Membro não encontrado',
    menu: {
      report: 'Denunciar membro',
      block: 'Bloquear membro',
      unblock: 'Desbloquear membro',
      privatePhotosSection: 'Fotos privadas',
      revokePrivatePhotos: {
        action: 'Revogar acesso',
        confirmTitle: 'Revogar acesso',
        confirmMessage:
          '{{userName}} não poderá mais ver suas fotos privadas. Ele(a) poderá enviar um novo pedido depois.',
        success: 'Acesso revogado',
        error: 'Falha ao revogar acesso',
      },
      forfeitPrivatePhotos: {
        action: 'Cancelar inscrição',
        confirmTitle: 'Cancelar inscrição',
        confirmMessage:
          'Você não poderá mais ver as fotos privadas de {{userName}}. Você pode solicitar acesso novamente depois.',
        success: 'Inscrição cancelada',
        error: 'Falha ao cancelar inscrição',
      },
    },
    block: {
      confirmMessage:
        'Tem certeza de que deseja bloquear {{userName}}? Esta ação não pode ser desfeita pelas próximas 72 horas para prevenir assédio.',
      success: 'Membro bloqueado com sucesso',
      error: 'Falha ao bloquear membro',
    },
    unblock: {
      confirmMessage:
        'Tem certeza de que deseja desbloquear {{userName}}? Esta ação não pode ser desfeita pelas próximas 72 horas para prevenir assédio.',
      success: 'Membro desbloqueado com sucesso',
      error: 'Falha ao desbloquear membro',
    },
    unfollow: {
      confirmTitle: 'Deixar de seguir',
      confirmMessage: 'Tem certeza de que deseja deixar de seguir {{userName}}?',
      success: 'Você não está mais seguindo {{userName}}',
      error: 'Falha ao deixar de seguir membro',
    },
    follow: {
      success: 'Agora você está seguindo {{userName}}',
      error: 'Falha ao seguir membro',
    },
    locked: {
      message: 'Atualize para {{premiumPlan}} para navegar por perfis de membros ilimitados.',
    },
  },
  userMenu: {
    viewProfile: 'Ver meu perfil',
    editProfile: 'Editar meu perfil',
    settings: 'Configurações',
    plans: 'Planos e assinatura',
    help: 'Ajuda e suporte',
    feedback: 'Feedback',
    rules: 'Regras da Comunidade',
    browseCommunities: 'Explorar comunidades',
    signOut: 'Sair',
  },
  editProfile: {
    title: 'Editar perfil',
    saveSuccess: 'Perfil atualizado com sucesso',
    saveError: 'Falha ao atualizar o perfil',
    loadError: 'Falha ao carregar o perfil',
    saving: 'Salvando...',
    sections: {
      basicInfo: 'Informações básicas',
    },
    firstName: 'Nome',
    firstNamePlaceholder: 'Digite seu nome',
    birthDate: 'Data de nascimento',
    selectYear: 'Selecionar ano',
    selectMonth: 'Selecionar mês',
    selectDay: 'Selecionar dia',
    selectHeight: 'Selecionar altura',
    weightGoal: 'Meta de peso',
    weightRangeError: 'O peso deve estar dentro do intervalo permitido',
    descriptionPlaceholder: 'Conte-nos sobre você...',
    textPlaceholder: 'Digite o texto...',
    notSet: 'Não definido',
    identifyAs: 'Me identifico como',
    myBodyType: 'Meu tipo de corpo',
    bodyTypesLiked: 'Tipos de corpo que gosto',
    bodyPartsLiked: 'Características físicas que gosto',
    myBodyHair: 'Meus pelos corporais',
    myFacialHair: 'Meus pelos faciais',
    hints: {
      firstName: 'Opcional. Aparece no seu perfil após seu nome de usuário.',
      birthDate:
        'Não visível para outros usuários. Usado para verificar que você é maior de idade e exibir sua idade.',
      bio: 'Conte aos outros sobre você, do que gosta e o que procura.',
    },
  },
  account: {
    plans: {
      title: 'Planos e assinatura',
      includedWith: 'O que está incluído com {{planName}}',
      choosePlan: 'Escolha seu plano',
      terms: 'Termos',
      bestValue: 'MELHOR VALOR',
      monthlyPlan: 'Plano Mensal {{planName}}',
      yearlyPlan: 'Plano Anual {{planName}}',
      regularPrice: 'Preço regular',
      perMonth: 'por mês',
      perYear: 'por ano',
      onlyPerMonth: 'Apenas {{price}}/mês (economize {{percent}}%)',
      pricesIn: 'Preços em {{currency}}.',
      billingTerms_ios:
        'O pagamento será cobrado na sua conta Apple após a confirmação da compra. Os planos são válidos pelo período selecionado e serão renovados automaticamente pelo preço listado, a menos que sejam cancelados pelo menos 24 horas antes do final do período atual. Você pode cancelar sua assinatura a qualquer momento nas configurações do dispositivo ou usando Gerenciar Assinatura acima.',
      billingTerms_android:
        'O pagamento será cobrado na sua conta Google após a confirmação da compra. Os planos são válidos pelo período selecionado e serão renovados automaticamente pelo preço listado, a menos que sejam cancelados pelo menos 24 horas antes do final do período atual. Você pode cancelar sua assinatura a qualquer momento nas configurações do dispositivo ou usando Gerenciar Assinatura acima.',
      billingTerms_web:
        'Os termos de assinatura e detalhes de cobrança serão fornecidos no checkout. Sua assinatura será renovada automaticamente, a menos que seja cancelada antes da data de renovação.',
      privacyPolicy: 'Política de Privacidade',
      termsOfUse: 'Termos de Uso',
      manageSubscription: 'Gerenciar assinaturas',
      currentPlan: 'Plano Atual',
      loading: 'Carregando planos...',
      confirming: 'Confirmando sua assinatura...',
      connecting: 'Conectando à loja...',
      connectionError: 'Erro de Conexão',
      openPlayStore: 'Abrir Play Store',
      signInToPlayStore: 'Entre no Google Play Store para continuar',
      openAppStore: 'Abrir App Store',
      checkAppStoreConnection: 'Verifique sua conexão com a App Store e tente novamente',
      premiumFeatures: {
        unlimitedPhotos: 'Visualização ilimitada de fotos',
        featureMorePhotosToRegularMembers: 'Mostre mais fotos suas para membros sem assinatura',
        unlimitedMessaging: 'Mensagens ilimitadas',
        moreBlocks: 'Mais bloqueios',
        morePhotoUploads: 'Mais uploads de fotos',
      },
      learnMoreAboutPlans: 'Saiba tudo sobre nossos planos',
      yourAccountIsOn: 'Sua conta está no plano {{planName}}',
      currentCreditsUntil: 'Créditos atuais válidos até:',
      daysLeft_one: '{{count}} dia restante',
      daysLeft_other: '{{count}} dias restantes',
      hoursLeft_one: '{{count}} hora restante',
      hoursLeft_other: '{{count}} horas restantes',
      subscriptionRenewalNote:
        'Sua assinatura renova automaticamente com base no seu ciclo de cobrança. Cada renovação adiciona créditos à sua conta. Créditos de promoções ou certificados de presente podem se estender além do período de assinatura atual. Obrigado por ser um membro {{planName}}!',
      billingNotAvailable: 'As assinaturas não estão disponíveis no momento',
      grandfatheredPricing: 'Parabéns! Você manteve nossos preços anteriores mais baixos.',
      oneMonth: 'Mensal',
      threeMonths: 'Trimestral',
      oneYear: 'Anual',
      oneYearCombo: 'Anual Duo',
      comboSubtitle: 'Inclui Grommr XL e 1 ano de Chasable+ (certificado de presente)',
      every3Months: 'a cada 3 meses',
      save: 'economize {{percent}}%',
      renewsEveryDays: 'Renova automaticamente a cada {{days}} dias',
      subscribe: 'Assinar',
      subscribed: 'Assinado',
      manageCCBill: 'Cancelar/gerenciar uma assinatura CCBill',
      subscriptionIdLabel: 'Seu ID de assinatura CCBill mais recente',
      subscriptionIdCopied: 'ID de assinatura copiado para a área de transferência',
      ccbillPayments: 'Pagamentos CCBill (Assinaturas)',
      ccbillDescription:
        'Usamos o CCBill para gerenciar nossa cobrança e existem várias maneiras de comprar seu passe com cartão de crédito: Aceitamos Visa, Mastercard, JCP e Discover. Seu extrato de cartão de crédito mostrará "CCBill.Com *Grokio" (Grokio Communities LLC é a empresa operadora por trás de {{communityName}}). Você tem a opção de realizar sua transação em uma das cinco moedas: USD; EUR; GBP; CAD; AUD; e JPY. Assim que recebermos a confirmação de que o pagamento foi feito, o novo tempo será adicionado à sua conta (na maioria dos casos isso deve ser imediato). Todas as assinaturas através do CCBill são renovadas automaticamente. Se você deseja cancelar sua assinatura, pode usar o link fornecido e cancelá-la pelo menos 48 horas antes de ser renovada.',
      billingFaq: 'Informações de Cobrança e Perguntas Frequentes',
      billingFaqDescription:
        'Confira nosso documento de Informações de Cobrança de {{planName}} para detalhes sobre pagamentos, renovações e cancelamentos.',
      billingFaqGuide: 'Guia para {{planName}}',
      getBillingSupport: 'Obter suporte de faturamento',
      restorePurchases: 'Restaurar compras',
      error: {
        loadProducts: 'Falha ao carregar planos de assinatura',
        noProductsFound: 'Nenhum produto de assinatura encontrado',
        purchase: 'Compra falhou',
        purchasePayment:
          'Sua compra não pôde ser concluída. Verifique seu método de pagamento e tente novamente.',
        purchaseNetwork:
          'Não foi possível conectar à loja. Verifique sua conexão com a internet e tente novamente.',
        purchaseUnavailable: 'Compras no app não estão disponíveis neste dispositivo ou conta.',
        purchaseAlreadyOwned: 'Você já possui uma assinatura ativa para este plano.',
        purchaseDeferred:
          'Seu pagamento está pendente de aprovação. A assinatura será ativada após a aprovação.',
        purchaseItemUnavailable: 'Este plano de assinatura não está disponível no momento.',
        validation: 'Falha ao validar compra',
        restore: 'Não foi possível restaurar — tente novamente ou contate o suporte',
        restoreUnavailable:
          'Não foi possível conectar à loja. Verifique sua conexão e tente novamente.',
      },
      success: {
        subscribedWithPlan: 'Obrigado por assinar! Seu plano {{planName}} está agora ativo.',
        subscribedWithBogo:
          'Obrigado por assinar! Seu {{planName}} está agora ativo. Bônus: Você ganhou um {{period}} extra com nossa promoção!',
        restored: 'Compras restauradas com sucesso',
        nothingToRestore: 'Nenhuma compra para restaurar',
      },
    },
    transactions: {
      title: 'Histórico de transações',
      empty: 'Nenhuma transação ainda',
      days_one: 'dia',
      days_other: 'dias',
      header: {
        date: 'Data',
        description: 'Descrição',
      },
    },
    certificates: {
      title: 'Certificados de Presente',
      history: 'Seus certificados de presente',
      empty: 'Nenhum certificado de presente ainda',
      purchase: 'Compra de Certificado de Presente',
      redeemed: 'Certificado de Presente Resgatado',
      redeemedOn: 'Resgatado em {{date}}',
      codeCopied: 'Código do certificado copiado para a área de transferência',
      redeem: {
        title: 'Resgatar um certificado de presente',
        helper: 'Digite o código que você recebeu para adicionar tempo premium à sua conta.',
        placeholder: 'XXXXX-XXXXX-XXXXX-XXXXX-XXXXX',
        button: 'Resgatar',
        success_one: 'Certificado de presente resgatado! {{count}} dia foi adicionado à sua conta.',
        success_other: 'Certificado de presente resgatado! {{count}} dias foram adicionados à sua conta.',
        invalidFormat: 'Isso não parece um código de certificado de presente. Os códigos têm 25 letras e números.',
        notFound: 'Não encontramos este código. Verifique se você está resgatando na comunidade para a qual ele foi emitido.',
        alreadyRedeemed: 'Este certificado de presente já foi resgatado.',
        tooManyAttempts: 'Muitas tentativas. Tente novamente amanhã.',
        error: 'Não foi possível resgatar este certificado de presente. Tente novamente mais tarde.',
      },
      header: {
        date: 'Data',
        details: 'Detalhes',
      },
    },
  },
  webDrop: {
    dropToUpload: 'Solte uma imagem para enviar',
    dragHint: 'Arraste uma imagem JPG/PNG aqui',
  },
  weightHistory: {
    stats: 'Estatísticas',
    currentWeight: 'Atual',
    trend: 'Tendência',
    bmi: 'IMC',
    goal: 'Meta',
    perMonth: '/mês',
    history: 'Histórico',
    date: 'Data',
    weight: 'Peso',
    notes: 'Notas',
    noData: 'Nenhum registro de peso ainda',
    noChartData: 'Dados insuficientes para o gráfico',
    addRecord: 'Adicionar',
    editRecord: 'Editar peso',
    selectDate: 'Selecionar data',
    notesPlaceholder: 'Notas opcionais...',
    added: 'Peso adicionado',
    updated: 'Peso atualizado',
    deleted: 'Registro de peso excluído',
    saveFailed: 'Falha ao salvar',
    deleteFailed: 'Falha ao excluir o registro',
    deleteTitle: 'Excluir',
    deleteConfirm: 'Excluir este registro de peso?',
  },
  footer: {
    support: 'Suporte',
    terms: 'Termos de uso',
    privacy: 'Política de privacidade',
  },
  report: {
    reasonTitle: 'Por que você está denunciando isto?',
    rulesLink: 'Leia as Regras da comunidade',
    reasons: {
      scam: 'Golpista',
      spam: 'Spam',
      falsePortrayal: 'Identidade falsa',
      harassment: 'Assédio',
      intolerance: 'Intolerância',
      trolling: 'Trollagem',
      disparagement: 'Difamação',
      donationRequest: 'Pedido de doações',
      promotionalPosting: 'Violação de publicação promocional',
      photoPolicy: 'Violação da política de fotos',
      uncreditedArtwork: 'Arte sem crédito',
      underage: 'Menor de idade',
      illegalActivity: 'Outras atividades ilegais',
      other: 'Outro',
    },
  },
};
